export default {
	huge: '1440px',
	wide: '1280px',
	'x-large': '1080px',
	large: '960px', // admin sidebar auto folds
	medium: '782px', // Adminbar goes big.
	small: '600px',
	mobile: '480px',
	'zoomed-in': '280px',
};
